import {
  afterNextRender,
  Component,
  computed,
  inject,
  signal,
  viewChildren,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { logError } from '@lp-ui-lib';
import { NgStyle } from '@angular/common';
import { forkJoin, fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { compareDesc } from 'date-fns';
import { formatDistanceToNow } from 'date-fns/esm';
import { de, enUS, pt } from 'date-fns/esm/locale';
import { AssetDetail, SensorMarker, TelemetryHistory, HeaderComponent } from '@lp-ui-lib';
import { GraphDisplay } from '../../models/classes/graphDisplay';
import { HistoryItemDetail } from '@lp-ui-lib';
import { MeasurementSystemSettings } from '@lp-ui-lib';
import { AdditionalInfoType, GroupedAdditionalInfo } from '@lp-ui-lib';
import { AdditionalInfo } from '@lp-ui-lib';
import { AssetsService } from '@lp-ui-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { UiService } from '@lp-ui-lib';
import { I18nService } from '@lp-ui-lib';
import { CurrentTelemetry } from '@lp-ui-lib';
import { GraphData } from '@lp-ui-lib';
import { environment } from '../../../environments/environment';
import { RotaingEquipmentStatus } from '../../models/classes/RotaingEquipmentStatus';
import { SpinnerComponent } from '@lp-ui-lib';
import { SidebarComponent } from '@lp-ui-lib';
import { BreadcrumbsComponent } from '@lp-ui-lib';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { SensorHealthStatus } from './sensor-health-status/sensor-health-status';
import { NavButtonComponent } from '@lp-ui-lib';
import { NotificationAlertComponent } from '../../components/notification-alert/notification-alert';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzListModule } from 'ng-zorro-antd/list';
import { SensorValueComponent } from '../../components/sensor-value/sensor-value';
import { TabBarComponent } from '../../components/tab-bar/tab-bar';
import { TabBarItemComponent } from '../../components/tab-bar/tab-bar-item/tab-bar-item';
import { TileComponent } from '@lp-ui-lib';
import { DocumentationWizardComponent } from '../../components/documentation-wizard/documentation-wizard';
import { HistoryItemComponent } from '../../components/history-item/history-item';
import { AssetOverviewMapComponent } from '../../components/map/asset-overview-map/asset-overview-map';
import { FormsModule } from '@angular/forms';
import { GLOBAL_CONSTANT, isValidDate } from '@lp-ui-lib';
import { SettingsService } from '@lp-ui-lib';
import { EquipmentUtil } from '@lp-ui-lib';
import { GraphComponent } from '../../components/graph/graph';
import { SteamTrapAnalytics } from './steam-trap-analytics/steam-trap-analytics';
import { AdditionalInfoEMComponent } from '../../components/additional-info/additional-info';
import { SensorSubscriptionComponent } from '../../components/sensor-subscription/sensor-subscription';
import { sanitize } from '@lp-ui-lib';
import { HealthStatusInfoPopupComponent } from '../../components/health-status-info/health-status-info-popup';
@Component({
  selector: 'app-asset-overview',
  imports: [
    NgStyle,
    SpinnerComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    NzModalModule,
    FormsModule,
    NzIconModule,
    NzProgressModule,
    NzImageModule,
    NzDescriptionsModule,
    NzDatePickerModule,
    TileComponent,
    SensorValueComponent,
    HistoryItemComponent,
    TileComponent,
    NzListModule,
    AssetOverviewMapComponent,
    NotificationAlertComponent,
    DocumentationWizardComponent,
    NavButtonComponent,
    SensorHealthStatus,
    TabBarItemComponent,
    TabBarComponent,
    GraphComponent,
    SteamTrapAnalytics,
    AdditionalInfoEMComponent,
    SensorSubscriptionComponent,
    HeaderComponent,
    HealthStatusInfoPopupComponent,
  ],
  templateUrl: './asset-overview.html',
  styleUrls: ['./asset-overview.scss'],
})
export class AssetOverview implements OnInit {
  asset = signal<any | null>(null);
  currentSensorID = signal<any | null>(null);
  parentName = signal<string>('');
  sensorMarkers = signal<SensorMarker[]>([]);
  resizeTrigger = signal<any>(null);
  loading = signal<boolean>(false);
  graphBrushActive = signal<boolean>(false);
  loadingSensors = signal<boolean>(false);
  overlayDocumentation = signal<boolean>(false);
  error = signal<any>(null);
  thumbnailLoading = signal<any>(null);
  thumbnailError = signal<boolean>(false);
  breadcrumbsLoading = signal<boolean>(false);
  addInfo = signal<boolean[]>([false, false, false]);
  showAllEntries = signal<boolean>(false);
  selectedSensor = signal<any | null>(null);
  overlayImage = signal<any>(null);
  graphDisplays = signal<GraphDisplay[]>([]);
  historyItems = signal<HistoryItemDetail[]>([]);
  loadingHistory = signal<boolean>(false);
  settings = signal<any | null>(null);
  rangePickerValue = signal<Date[]>([new Date(), new Date()]);
  npToken = signal<any>(null);
  npResp = signal<any>(null);
  ssoToken = signal<any>(null);
  ssoParams = signal<any>(null);
  rotatingAssetDetails = signal<RotaingEquipmentStatus[]>([]);
  lastTimeframeSelectIndex = signal<number>(0);
  loadingRotatingData = signal<boolean>(false);
  healthStatusEmptyResponse = signal<boolean>(false);
  rotatingEqWorkingFine = signal<boolean>(false);
  rotatingEqWarning = signal<boolean>(false);
  rotatingEqCritical = signal<boolean>(false);
  rotatingEqInactive = signal<boolean>(false);
  systemStatusOnlineLearningNodata = signal<boolean>(false);
  NPSystemStatus = signal<string[]>(['online', 'learning', 'na']);

  datePickers = viewChildren<any>('datePick');

  additionalInfoLoading = signal<boolean>(false);
  additionalInfoError = signal<any>(null);
  loadingNotifications = signal<boolean>(false);
  addInfoValueTypes = signal<AdditionalInfoType[]>([]);
  addInfoDefaultFields = signal<AdditionalInfo[]>([]);
  groupedInfoValues = signal<GroupedAdditionalInfo[]>([]);
  sensorPosition = signal<{ lat: number; lng: number } | null>(null);
  openInfoPopup = signal<boolean>(false);

  range = signal<Date[]>([new Date(new Date().setDate(new Date().getDate() - 1)), new Date()]);

  private settingService = inject(SettingsService);
  private destroyRef = inject(DestroyRef);
  private assetsService = inject(AssetsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private ui = inject(UiService);
  public i18n = inject(I18nService);

  ngOnInit(): void {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => this.onParamMapChange(params));
  }

  constructor() {
    fromEvent(window, 'resize')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const triggerFn = this.resizeTrigger();
        if (triggerFn) triggerFn();
      });

    this.ui.onNavBack(() => {
      const assetVal = this.asset();
      const sensorId = this.selectedSensor();

      if (!assetVal) {
        this.router.navigate(['home'], { replaceUrl: true });
      } else if (sensorId) {
        this.onSensorDeselect();
      } else {
        let parent: any | null = this.assetsService.findLocation(assetVal.parentID);
        while (parent && parent.curLayer !== 'c') {
          parent = this.assetsService.findLocation(parent.parentID);
        }
        if (parent) {
          if (parent.isAsset) {
            this.router.navigate(['asset', assetVal.parentID]);
          } else {
            this.router.navigate(['plant', parent.objectID], {
              replaceUrl: true,
            });
          }
        } else {
          this.router.navigate(['home'], { replaceUrl: true });
        }
      }
    });

    afterNextRender(() => {
      if (this.isRotating()) {
        this.ui.updateTabIndex(this.route.snapshot.data['tabIndex']);
        this.ui.updateBackBtn(this.route.snapshot.data['backBtn']);
      }
    });
  }

  HistoryItems = computed(() => {
    const items = this.historyItems();
    const sensorId = this.selectedSensor();
    if (!items) return [];
    return items.filter((item) => !sensorId || sensorId === item.sensorID || !item.sensorID);
  });

  SensorTiles = computed(() => {
    const assetVal = this.asset();
    if (!assetVal) return [];
    return [
      assetVal?.SensorTileTelemetryEM?.map((_telemetry: any) => {
        _telemetry.telemetry = _telemetry.telemetry.map((t: any) => t);
        return _telemetry;
      })[0],
    ];
  });

  SensorDetailedTelemetry = computed(() => {
    const assetVal = this.asset();
    const sensorVal = this.Sensor();
    if (!assetVal || !sensorVal) return [];
    const detailedTelemetry = assetVal.getSensorDetailTelemetryEM(this.Sensor().sensorID);
    return detailedTelemetry
      ? detailedTelemetry
          .map((_telemetry: any) => {
            _telemetry.telemetry = _telemetry.telemetry.map((t: any) => t);
            return _telemetry;
          })
          .map((item: any) => item.telemetry)
          .flat(2)
      : [];
  });

  SensorDetailedTelemetryJSON = computed(() => {
    try {
      return JSON.stringify(this.SensorDetailedTelemetry());
    } catch (e) {
      return String(e);
    }
  });

  SteamLossPrediction = computed(() => {
    const assetVal = this.asset();
    if (!assetVal || !assetVal.steamTrap) return [];
    return assetVal.steamTrap.filter((telemetry: any) =>
      [
        GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_MASS_WEEK_ID,
        GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_MASS_MONTH_ID,
        GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_MASS_3MONTH_ID,
        GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_AMOUNT_WEEK_ID,
        GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_AMOUNT_MONTH_ID,
        GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_AMOUNT_3MONTH_ID,
      ].includes(telemetry.measurementTypeID)
    );
    return [];
  });

  Range = computed(() => this.range());
  DateFormat = computed(() => this.settings()?.dateFormat?.formatString ?? '');
  Locale = computed(() => {
    const lang = this.settings()?.language?.abbreviation;
    return lang === 'de' ? 'de-DE' : lang === 'pt' ? 'pt-PT' : 'en-US';
  });

  Sensor = computed(() => {
    const assetVal = this.asset();
    const sensorId = this.selectedSensor();
    if (!assetVal || !sensorId) return null;

    const sid = Number(sensorId);
    return assetVal.sensors.find((s: any) => Number(s.sensorID) === sid) ?? null;
  });

  Breadcrumbs: any = computed(() => {
    const assetVal = this.asset();
    const sensorVal = this.Sensor();
    if (!assetVal) return [];
    return !sensorVal ? assetVal.breadcrumbs : assetVal.breadcrumbs.concat(assetVal);
  });

  Temperature = computed(() => {
    const assetVal = this.asset();
    if (!assetVal || !assetVal.temperature) return [];
    return [
      {
        title: assetVal?.temperature?.title,
        icon: 'temperature',
        telemetry: [assetVal.temperature],
      },
    ];
  });

  LoadingSensors = computed(() => this.loadingSensors() || this.loadingNotifications());

  SensorHealth = computed(() => {
    const assetVal = this.asset();
    if (!assetVal || !assetVal.health?.length) return [];
    return assetVal.health.filter((t: any) =>
      ['battery', 'signal', 'tilt'].some((key) => t?.title?.toLowerCase().includes(key))
    );
  });

  sensorGeoPosition = computed(() => {
    const sensor = this.Sensor();
    const position = sensor?.geoPosition ? sensor.geoPosition.split(';', 2) : ['', ''];
    return { lat: Number(position[0]), lng: Number(position[1]) };
  });

  IsSteamTrap = computed(() => !!this.asset() && this.asset()?.steamTrap?.length > 0);
  IsPipe = computed(() => !!this.asset() && this.asset()!.equipmentType === 'Pipe');
  isRotating = computed(
    () => !!this.asset() && this.asset()!.equipmentType === 'Rotating Equipment'
  );

  HasSteamTrapAnalytics = computed(() => {
    const displays = this.graphDisplays();
    const assetVal = this.asset();
    return (
      !!displays.find((item: any) => item.currentTelemetry.page === 'steam_trap') &&
      !!assetVal?.steamTrap.find((t: any) => t.measurementTypeID === 1068)
    );
  });

  HasLeakageSensors = computed(() => {
    const assetVal = this.asset();
    return !!assetVal?.sensors.find((sensor: any) =>
      sensor.telemetry.some((t: any) => t.measurementTypeID === 1078)
    );
  });

  SteamTrapOutlet = computed(() =>
    this.asset()?.steamTrap.find((t: any) => t.measurementTypeID === 1074)
  );

  SteamTrapAnalyticsLoading = computed(() =>
    this.graphDisplays().some(
      (item: any) => item.currentTelemetry.page === 'steam_trap' && item.loading
    )
  );

  SteamTrapGraphData = computed(() =>
    this.graphDisplays()
      .filter((item: any) => item.currentTelemetry.page === 'steam_trap')
      .map((display) => display.graphData)
      .flat(2)
  );

  SteamTrapGraphDisplays = computed(() =>
    this.graphDisplays().filter((item: any) => item.currentTelemetry.page === 'steam_trap')
  );

  SteamTrapTelemetry = computed(() =>
    this.graphDisplays()
      .filter((item: any) => item.currentTelemetry.page === 'steam_trap')
      .map((display) => display.currentTelemetry)
  );

  SteamLossCurrencyUnit = computed(() => {
    if (environment.disableSelectedSteamRateCurrency) return '€';
    return this.asset()?.additionalInfo.find((item: any) =>
      item.category.includes('currency_steam_rate_currency')
    );
  });

  SteamTrapNoPricePerTon = computed(() => {
    const assetVal = this.asset();
    const pricePerTon = assetVal?.additionalInfo.find((item: any) =>
      item.category.includes('Price per ton')
    );
    const pricePerTonValue = pricePerTon?.value ?? null;
    return this.HasSteamTrapAnalytics() && !pricePerTonValue;
  });

  IsTelemetryTimeframeCustom = computed(() => {
    const temp = this.SteamTrapTelemetry()[0];
    return temp ? this.isTelemetryTimeframeCustom(temp) : false;
  });

  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());
  isDesktop = computed(() => this.ui.IsDesktop());

  toTechnicalDocuments() {
    const assetVal = this.asset();
    if (!assetVal) return;

    if (assetVal.equipmentType === 'Flange') {
      this.router.navigate(['settings', 'technical_documents', 'flange']);
    } else if (assetVal.equipmentType === 'Rotating Equipment') {
      this.router.navigate(['settings', 'technical_documents', 'rotatingequipment']);
    } else {
      this.router.navigate(['settings', 'technical_documents', 'steamtrap']);
    }
  }

  GroupedAdditionalInfo = computed(() => {
    const assetVal = this.asset();
    if (!assetVal) return [];

    const groupBy = (xs: any[], key: string) =>
      xs.reduce(
        (rv, x) => {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        },
        {} as Record<string, any[]>
      );

    const grouped = groupBy(assetVal.additionalInfo, 'category');
    return Object.keys(grouped).map((key) => ({
      header: key,
      items: grouped[key],
    }));
  });

  Notifications: any = computed(() => {
    const assetVal = this.asset();
    const sensorId = this.selectedSensor();
    const isRotatingVal = this.isRotating();

    if (assetVal && !isRotatingVal) {
      return assetVal.notifications
        .filter((n: any) => n.sensorID === sensorId || (!n.sensorID && !sensorId))
        .sort((a: any, b: any) =>
          a.timestamp < b.timestamp ? 1 : a.timestamp > b.timestamp ? -1 : 0
        );
    } else if (assetVal && isRotatingVal) {
      return assetVal.notifications.sort((a: any, b: any) =>
        a.timestamp < b.timestamp ? 1 : a.timestamp > b.timestamp ? -1 : 0
      );
    }
    return [];
  });

  private onParamMapChange(params: any) {
    try {
      const sensorId = params.get('sensorid');
      const assetId = +params.get('id');

      if (sensorId && +sensorId > 0) {
        this.selectedSensor.set(+sensorId);
      } else {
        this.selectedSensor.set(null);
      }

      if (!this.asset() || this.asset()!.objectID !== assetId) {
        this.refresh(assetId);
      } else {
        this.refreshHistory(assetId);
      }

      if (this.selectedSensor() && this.selectedSensor()! > 0) {
        this.ui.setBackText(
          this.i18n.parse(this.Sensor() ? this.asset()!.objectName : this.parentName())
        );
        setTimeout(() => {
          this.sensorMarkers.update((markers) =>
            markers.map((marker) => {
              const updatedMarker = Object.assign({}, marker, {
                selected: marker.sensorID === this.selectedSensor(),
                hidden: marker.sensorID !== this.selectedSensor(),
              });
              return updatedMarker;
            })
          );

          this.loadTelemetry();
        });
      } else {
        this.ui.setBackText(this.i18n.parse(this.parentName()));
        if (this.IsSteamTrap()) this.loadTelemetry();
        setTimeout(() => {
          this.sensorMarkers.update((markers) =>
            markers.map((marker) => ({
              ...marker,
              selected: false,
              hidden: false,
            }))
          );
        });
      }
    } catch (e) {
      logError(e);
      console.error('An error occurred. Please try again later');
    }
  }

  private refresh(assetID: number, disableCache = false) {
    this.loading.set(true);
    this.error.set(false);

    this.settingService.getUserSettings().then((settings: any) => {
      this.settings.set(settings);

      this.assetsService.subscribeToAsset(
        assetID,
        disableCache,
        settings.MeasurementSystem,
        (result: any) => {
          const loadTelemetry =
            !!disableCache || !this.asset() || this.asset()!.objectID !== assetID;
          if (result.asset.objectID !== assetID) return;

          this.loading.set(false);
          this.breadcrumbsLoading.set(result.breadcrumbsLoading);
          this.asset.set(result.asset);

          const parent: any = this.getParentForBackNav(result.asset.parentID);
          this.parentName.set(parent ? parent.objectName : this.i18n.langString('home'));

          this.ui.setBackText(
            this.Sensor()
              ? this.i18n.parse(result.asset.objectName)
              : this.i18n.parse(this.parentName())
          );

          if (!result.asset.picture) {
            result.asset.picture = this.isRotating()
              ? EquipmentUtil.getDefaultImage(
                  result.asset.equipmentType,
                  result.asset.defaultImageId
                )
              : EquipmentUtil.getDefaultImage(result.asset.equipmentType);
          }

          if (this.thumbnailLoading() === null) {
            this.thumbnailLoading.set(true);
            this.thumbnailError.set(false);
            this.sensorMarkers.set([]);
          }

          if (
            !this.loadingSensors() &&
            (!result?.asset?.sensors?.length || !result.asset.sensors[0]?.telemetry?.length)
          ) {
            this.loadSensors(loadTelemetry, disableCache, settings.MeasurementSystem);
            this.loadAdditionalInfo();
          }
        },
        () => {
          this.loading.set(false);
          this.error.set(true);
        }
      );
    });

    this.refreshHistory(assetID);
  }

  private refreshHistory(assetID: number) {
    this.loadingHistory.set(true);
    this.assetsService.getObjectHistory(assetID, this.selectedSensor() ?? -1, 6).then((result) => {
      this.historyItems.set(result);
      this.loadingHistory.set(false);
    });
  }

  isSystemStatusValidRotEq = computed(() => {
    const details = this.rotatingAssetDetails();
    const status = details[0]?.systemStatusV2?.toLowerCase();
    return (
      ['online', 'learning', 'no data', 'na'].includes(status) ||
      details[0]?.systemStatusV2 === 'Learning_Initial'
    );
  });

  isHealthStatusNotAvailable = computed(
    () =>
      this.systemStatusOnlineLearningNodata() &&
      !this.rotatingEqWorkingFine() &&
      !this.rotatingEqWarning() &&
      !this.rotatingEqCritical() &&
      !this.rotatingEqInactive()
  );

  getProgressStrokeColor(lifePercentage: any): string {
    return lifePercentage > 50 ? '#00AA75' : lifePercentage > 20 ? '#ecb102' : '#e1000f';
  }

  rotatingEqAssetDetails() {
    const assetVal = this.asset();
    if (!assetVal) return;

    this.loadingRotatingData.set(true);

    this.assetsService.getNanoPreciseAssetsHealthStatus(assetVal.objectID).then((result) => {
      this.rotatingAssetDetails.set(result);

      if (result?.length > 0) {
        this.healthStatusEmptyResponse.set(false);
        const status = result[0]?.systemStatusV2.toLowerCase();

        if (this.NPSystemStatus().includes(status)) {
          this.systemStatusOnlineLearningNodata.set(true);
          this.checkHealthStatus(result[0].healthStatusV2);

          result[0].lifePercentage =
            typeof result[0]?.lifePercentage === 'string' &&
            result[0]?.lifePercentage.toLowerCase() === 'learning'
              ? '100'
              : Math.trunc(parseInt(result[0].lifePercentage)).toString();

          this.loadingRotatingData.set(false);
        } else {
          this.checkSystemStatusRotEq(result[0]?.systemStatusV2);
          this.loadingRotatingData.set(false);
        }
      } else {
        this.loadingRotatingData.set(false);
        this.healthStatusEmptyResponse.set(true);
      }
    });
  }

  checkSystemStatusRotEq(systemStatusV2: string) {
    if (systemStatusV2 === 'Learning_Initial') {
      this.rotatingAssetDetails.update((details) => {
        if (details[0]) details[0].lifePercentage = '100';
        return details;
      });
      this.systemStatusOnlineLearningNodata.set(true);
      this.rotatingEqWorkingFine.set(true);
      this.rotatingEqWarning.set(false);
      this.rotatingEqCritical.set(false);
      this.rotatingEqInactive.set(false);

      this.assetsService.rotatingEqWorkingFineSig.set(true);
      this.assetsService.rotatingEqWarningSig.set(false);
      this.assetsService.rotatingEqCriticalSig.set(false);
      this.assetsService.rotatingEqInactiveSig.set(false);
    } else if (systemStatusV2.toLowerCase() === 'no data') {
      this.rotatingAssetDetails.update((details) => {
        if (details[0]) {
          details[0].lifePercentage =
            typeof details[0]?.lifePercentage === 'string' &&
            details[0]?.lifePercentage.toLowerCase() === 'learning'
              ? '100'
              : Math.trunc(parseInt(details[0].lifePercentage)).toString();
        }
        return details;
      });
      this.systemStatusOnlineLearningNodata.set(true);
      this.rotatingEqCritical.set(false);
      this.rotatingEqWorkingFine.set(false);
      this.rotatingEqInactive.set(true);
      this.rotatingEqWarning.set(false);

      this.assetsService.rotatingEqWorkingFineSig.set(false);
      this.assetsService.rotatingEqWarningSig.set(false);
      this.assetsService.rotatingEqCriticalSig.set(false);
      this.assetsService.rotatingEqInactiveSig.set(true);
    } else {
      this.systemStatusOnlineLearningNodata.set(false);
    }
  }

  checkHealthStatus(healthStatus: string) {
    const status = healthStatus.toLowerCase();

    if (status === 'acceptable') {
      this.rotatingEqWorkingFine.set(true);
      this.rotatingEqWarning.set(false);
      this.rotatingEqCritical.set(false);
      this.rotatingEqInactive.set(false);

      this.assetsService.rotatingEqWorkingFineSig.set(true);
      this.assetsService.rotatingEqWarningSig.set(false);
      this.assetsService.rotatingEqCriticalSig.set(false);
      this.assetsService.rotatingEqInactiveSig.set(false);
    } else if (
      status === GLOBAL_CONSTANT.UNACCEPTABLE ||
      status === GLOBAL_CONSTANT.NEEDS_IMMEDIATE_ATTENTION
    ) {
      this.rotatingEqWorkingFine.set(false);
      this.rotatingEqWarning.set(false);
      this.rotatingEqCritical.set(true);
      this.rotatingEqInactive.set(false);

      this.assetsService.rotatingEqWorkingFineSig.set(false);
      this.assetsService.rotatingEqWarningSig.set(false);
      this.assetsService.rotatingEqCriticalSig.set(true);
      this.assetsService.rotatingEqInactiveSig.set(false);
    } else if (status === 'unsatisfactory' || status === 'trending') {
      this.rotatingEqWorkingFine.set(false);
      this.rotatingEqWarning.set(true);
      this.rotatingEqCritical.set(false);
      this.rotatingEqInactive.set(false);

      this.assetsService.rotatingEqWorkingFineSig.set(false);
      this.assetsService.rotatingEqWarningSig.set(true);
      this.assetsService.rotatingEqCriticalSig.set(false);
      this.assetsService.rotatingEqInactiveSig.set(false);
    } else if (status === 'no data') {
      this.assetsService.rotatingEqWorkingFineSig.set(false);
      this.assetsService.rotatingEqWarningSig.set(false);
      this.assetsService.rotatingEqCriticalSig.set(false);
      this.assetsService.rotatingEqInactiveSig.set(true);
    } else {
      this.rotatingEqWorkingFine.set(false);
      this.rotatingEqWarning.set(false);
      this.rotatingEqCritical.set(false);
      this.rotatingEqInactive.set(false);
    }
  }

  loadSensors(
    loadTelemetry: boolean,
    disableCache: boolean,
    measurementSystem: MeasurementSystemSettings
  ) {
    const assetVal = this.asset();
    if (!assetVal) return;

    this.loadingSensors.set(true);

    this.assetsService.subscribeToSensors(
      assetVal.objectID,
      disableCache,
      measurementSystem,
      (result) => {
        try {
          const updatedAsset = new AssetDetail({ ...assetVal, ...result }, assetVal.breadcrumbs);

          this.asset.set(updatedAsset);

          this.loadNotifications();

          if (loadTelemetry) {
            if (this.isRotating()) {
              this.rotatingEqAssetDetails();
            }
            this.loadTelemetry();
          }
        } finally {
          this.loadingSensors.set(false);
        }
      },
      () => {
        this.loadingSensors.set(false);
        this.error.set(true);
      }
    );
  }

  loadTelemetry() {
    const assetVal = this.asset();
    if (!assetVal) return;

    const telemetryList: CurrentTelemetry[] = [];

    if (this.Sensor()) {
      this.SensorDetailedTelemetry().forEach((t: CurrentTelemetry) => telemetryList.push(t));
    }
    if (!!assetVal.steamTrap && !this.Sensor()) {
      assetVal.steamTrap
        .filter(
          (t: CurrentTelemetry) =>
            t.measurementTypeID === GLOBAL_CONSTANT.STEAM_TRAP_STATUS_ID ||
            t.measurementTypeID === GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_AMOUNT_ID ||
            t.measurementTypeID === GLOBAL_CONSTANT.STEAM_TRAP_STEAM_LOSS_MASS_ID
        )
        .forEach((t: CurrentTelemetry) => telemetryList.push(t));
    }
    const graphDisplays: any = telemetryList
      .filter((t) => !!this.Sensor() || t.preload)
      .map((telemetry) => {
        const end: any =
          telemetry?.Timestamp && isValidDate(telemetry.Timestamp)
            ? telemetry.Timestamp
            : new Date();
        const defaultTimeframe = {
          start: new Date(new Date(end).setDate(end.getDate() - 7)),
          end,
        };
        const defaultLoadedTimeframe = {
          start: new Date(new Date(end).setMonth(end.getMonth() - 6)),
          end,
        };

        const currentRange = this.range();

        if (
          !currentRange ||
          !(currentRange[0] instanceof Date) ||
          !(currentRange[1] instanceof Date)
        ) {
          this.range.set([defaultTimeframe.start, defaultTimeframe.end]);
        }

        return Object.assign(new GraphDisplay(), {
          graphData: null,
          history: null,
          loading: true,
          timeframe: defaultTimeframe,
          loadedTimeframe: defaultLoadedTimeframe,
          currentTelemetry: telemetry,
        });
      });
    const enrichedGraphDisplays = this.calcCo2GraphData(graphDisplays);
    if (enrichedGraphDisplays) graphDisplays.push(enrichedGraphDisplays);

    this.graphDisplays.set(graphDisplays);

    graphDisplays
      .filter((item: any) => item.currentTelemetry.measurementTypeID !== 9999)
      .forEach((graphTelemetry: any) => {
        const loadedTimeframe: any = this.getLoadedTimeframe(graphTelemetry.currentTelemetry);
        graphTelemetry.loading = true;
        if (graphTelemetry.graphData)
          graphTelemetry.graphData.forEach((data: any) => (data.loading = true));

        const sensorID = this.Sensor()?.sensorID ?? assetVal?.sensors?.[0]?.sensorID;
        this.currentSensorID.set(sensorID);
        if (!sensorID) return;

        this.assetsService
          .getTelemetry(
            assetVal.objectID,
            sensorID,
            graphTelemetry?.currentTelemetry?.measurementTypeID,
            this.settings()?.measurementSystem,
            loadedTimeframe
          )
          .then((rawResult: TelemetryHistory) => {
            const result = Object.assign(new TelemetryHistory(), rawResult);

            // fix metadata thresholds by copying from sensor telemetry (your existing logic)
            result.metadata = result.metadata.map((m: any) => {
              const t = this.Sensor()?.telemetry?.find(
                (x: any) => x.measurementTypeID === m.measurementTypeID
              );
              return t
                ? {
                    ...m,
                    critical: t.critical,
                    warning: t.warning,
                    inactive: t.inactive,
                  }
                : m;
            });

            const graphData = result.GetGraphData();

            // Update the signal immutably (THIS is the real fix)
            this.graphDisplays.update((list) =>
              list.map((d) => {
                if (
                  d.currentTelemetry?.measurementTypeID ===
                    graphTelemetry.currentTelemetry?.measurementTypeID &&
                  d.currentTelemetry?.sensor?.sensorID ===
                    graphTelemetry.currentTelemetry?.sensor?.sensorID
                ) {
                  return Object.assign(new GraphDisplay(), {
                    ...d,
                    history: result,
                    graphData,
                    loading: false,
                    error: false,
                  });
                }
                return d;
              })
            );

            // Ensure initial visibility/timeframe is applied automatically (so user doesn't have to click tabs)
            queueMicrotask(() => {
              this.onTelemetryTimeframeSelect(
                this.lastTimeframeSelectIndex(),
                graphTelemetry.currentTelemetry
              );
            });

            // CO2 special case stays same
            if (graphTelemetry.currentTelemetry.measurementTypeID === 1070) {
              this.fillCo2GraphData();
            }
          })
          .catch((err) => {
            console.error(err);

            // also update error immutably
            this.graphDisplays.update((list) =>
              list.map((d) => {
                if (
                  d.currentTelemetry?.measurementTypeID ===
                    graphTelemetry.currentTelemetry?.measurementTypeID &&
                  d.currentTelemetry?.sensor?.sensorID ===
                    graphTelemetry.currentTelemetry?.sensor?.sensorID
                ) {
                  return Object.assign(new GraphDisplay(), {
                    ...d,
                    loading: false,
                    error: true,
                  });
                }
                return d;
              })
            );
          });
      });
  }

  reloadTelemetry(graphTelemetry: GraphDisplay) {
    graphTelemetry.graphData.forEach((data) => (data.loading = true));

    this.assetsService
      .getTelemetry(
        this.asset()?.objectID,
        graphTelemetry.currentTelemetry.sensor.sensorID,
        graphTelemetry.currentTelemetry.measurementTypeID,
        this.settings()?.MeasurementSystem,
        graphTelemetry.loadedTimeframe
      )
      .then((result: TelemetryHistory) => {
        graphTelemetry.loading = false;

        graphTelemetry.history = result;
        graphTelemetry.history.metadata = graphTelemetry.history.metadata.map((metadata: any) => {
          const telemetry = this.Sensor()?.telemetry.find(
            (item: any) => item.measurementTypeID === metadata.measurementTypeID
          );
          if (telemetry) {
            metadata.critical = telemetry.critical;
            metadata.warning = telemetry.warning;
          }
          return metadata;
        });

        graphTelemetry.graphData = graphTelemetry.history.GetGraphData();
        graphTelemetry.graphData.forEach((data) => {
          data.loading = false;
          data.error = false;
        });

        if (graphTelemetry.currentTelemetry.measurementTypeID === 1070) {
          this.fillCo2GraphData();
        }
      })
      .catch((error) => {
        graphTelemetry.graphData.forEach((data) => {
          logError(error);
          data.loading = false;
          data.error = true;
        });
      });
  }

  calcCo2GraphData(graphDisplays: GraphDisplay[]): GraphDisplay | null {
    if (!graphDisplays) return null;

    const STEAM_TRAP_STEAM_LOSS_MASS_ID = 1070;
    const STEAM_TRAP_STEAM_LOSS_CO2_ID = 9999;
    const CO2_CONVERSION_FACTOR = 0.16;

    interface GraphDisplay {
      currentTelemetry?: {
        measurementTypeID?: number | string;
      };
    }

    const steamTrapLossMass = (graphDisplays as GraphDisplay[])?.find(
      (display) => display?.currentTelemetry?.measurementTypeID === STEAM_TRAP_STEAM_LOSS_MASS_ID
    );

    const existingCo2Data = graphDisplays.find(
      (display: any) => display.currentTelemetry.measurementTypeID === STEAM_TRAP_STEAM_LOSS_CO2_ID
    );
    if (existingCo2Data || !steamTrapLossMass) return null;

    const getCircularReplacer = () => {
      const seen = new WeakSet();
      return (key: string, value: any) => {
        if (typeof value === 'object' && value !== null) {
          if (seen.has(value)) return;
          seen.add(value);
        }
        return value;
      };
    };

    const sanitizedData = sanitize(
      JSON.parse(JSON.stringify(steamTrapLossMass, getCircularReplacer()))
    );

    const { title, value, unit, data } = sanitizedData;

    // Avoid Object.assign() and only set expected properties
    const steamTrapLossCo2: any = new GraphDisplay();

    steamTrapLossCo2.title = title;
    steamTrapLossCo2.value = value;
    steamTrapLossCo2.unit = unit;
    steamTrapLossCo2.data = data;

    if (steamTrapLossCo2.currentTelemetry && steamTrapLossCo2.currentTelemetry.value) {
      steamTrapLossCo2.currentTelemetry.measurementTypeID = STEAM_TRAP_STEAM_LOSS_CO2_ID;

      steamTrapLossCo2.currentTelemetry.measurementType = 'CO2 Emissions';

      steamTrapLossCo2.currentTelemetry.value.val =
        (steamTrapLossCo2.currentTelemetry.value.val ?? 0) * CO2_CONVERSION_FACTOR;
    }

    // SECURE CODE - Validate and sanitize before assignment
    const telemetry =
      steamTrapLossCo2?.currentTelemetry && typeof steamTrapLossCo2.currentTelemetry === 'object'
        ? sanitize(steamTrapLossCo2.currentTelemetry)
        : {};

    steamTrapLossCo2.currentTelemetry = {
      measurementTypeID: telemetry.measurementTypeID,
      measurementType: telemetry.measurementType,
      value: telemetry.value,
    };

    return steamTrapLossCo2;
  }

  fillCo2GraphData() {
    const STEAM_TRAP_STEAM_LOSS_MASS_ID = 1070;
    const STEAM_TRAP_STEAM_LOSS_CO2_ID = 9999;
    const CO2_CONVERSION_FACTOR = 0.16;

    const graphDisplays = this.graphDisplays();
    const steamTrapLossMass = graphDisplays.find(
      (display: any) => display.currentTelemetry.measurementTypeID === STEAM_TRAP_STEAM_LOSS_MASS_ID
    );
    const steamTrapLossCo2 = graphDisplays.find(
      (display: any) => display.currentTelemetry.measurementTypeID === STEAM_TRAP_STEAM_LOSS_CO2_ID
    );

    if (!steamTrapLossMass || !steamTrapLossCo2 || !steamTrapLossMass.graphData) return;

    steamTrapLossCo2.graphData = JSON.parse(JSON.stringify(steamTrapLossMass.graphData))?.map(
      (data: any) => Object.assign(new GraphData(), data)
    );

    steamTrapLossCo2.graphData.forEach((data) => {
      data.metadata.measurementTypeID = STEAM_TRAP_STEAM_LOSS_CO2_ID;
      data.telemetry.forEach((telemetry: any) => {
        telemetry.measurementTypeID = STEAM_TRAP_STEAM_LOSS_CO2_ID;
        telemetry.value = telemetry.value * CO2_CONVERSION_FACTOR;
      });
    });

    steamTrapLossCo2.loading = false;
  }

  groupBy<T>(arr: T[], key: keyof T): T[][] {
    return Object.values(
      arr.reduce((acc: Record<string, T[]>, item: T) => {
        const groupKey = String(item[key]);
        (acc[groupKey] = acc[groupKey] || []).push(item);
        return acc;
      }, {})
    );
  }

  lastChecked = computed(() => {
    const sensorHealth = this.SensorHealth();
    if (!sensorHealth || sensorHealth?.length === 0) return null;

    const filteredTelemetry = Array.from(sensorHealth).sort((a: any, b: any) =>
      !a.Timestamp || !b.Timestamp ? 0 : compareDesc(a.Timestamp, b.Timestamp)
    );

    const latest: any = filteredTelemetry[0];
    if (latest && latest.Timestamp && isValidDate(latest.Timestamp)) {
      return formatDistanceToNow(latest.Timestamp, {
        locale:
          this.i18n.languageSignal() === 'de'
            ? de
            : this.i18n.languageSignal() === 'pt'
              ? pt
              : enUS,
      });
    }
    return null;
  });

  isSensorHealthCrit = computed(() => {
    const sensorHealth = this.SensorHealth();
    return sensorHealth ? sensorHealth.some((sensor: any) => sensor.critical) : false;
  });

  isSensorHealthWarning = computed(() => {
    const sensorHealth = this.SensorHealth();
    return sensorHealth ? sensorHealth.some((sensor: any) => sensor.warning) : false;
  });

  noData(data: GraphData): boolean {
    return !data || data?.telemetry?.length === 0;
  }

  noDataTelemetry(telemetry: CurrentTelemetry): boolean {
    return !this.getVisibleGraphs(telemetry).some((data: GraphData) => !this.noData(data));
  }

  isGraphLoading(telemetry: any): boolean {
    const display = this.graphDisplays().find(
      (graphDisplay: any) =>
        graphDisplay.currentTelemetry.measurementTypeID === telemetry.measurementTypeID &&
        graphDisplay.currentTelemetry.sensor.sensorID === telemetry.sensor.sensorID
    );
    return !display || display.loading;
  }

  getVisibleGraphs(telemetry: any): any[] {
    const display: any = this.graphDisplays().find(
      (graphDisplay: any) =>
        graphDisplay.currentTelemetry.measurementTypeID === telemetry.measurementTypeID &&
        graphDisplay.currentTelemetry.sensor.sensorID === telemetry.sensor.sensorID
    );

    const result =
      display && display.graphData
        ? display.graphData.filter((graphData: any) => graphData.metadata.displayGraph)
        : [];
    return result;
  }

  getTimeframe(telemetry: any): { start: Date; end: Date; custom?: boolean } | any {
    const display = this.graphDisplays().find(
      (graphDisplay: any) =>
        graphDisplay.currentTelemetry.measurementTypeID === telemetry.measurementTypeID &&
        graphDisplay.currentTelemetry.sensor.sensorID === telemetry.sensor.sensorID
    );
    return display ? display.timeframe : null;
  }

  resetTimeframeSelect(telemetry: CurrentTelemetry) {
    this.onTelemetryTimeframeSelect(this.lastTimeframeSelectIndex(), telemetry);
  }

  getLoadedTimeframe(telemetry: any): { start: Date; end: Date; custom?: boolean } | null {
    const display = this.graphDisplays().find(
      (graphDisplay: any) =>
        graphDisplay?.currentTelemetry?.measurementTypeID === telemetry?.measurementTypeID &&
        graphDisplay?.currentTelemetry?.sensor?.sensorID === telemetry?.sensor?.sensorID
    );
    return display ? display.loadedTimeframe : this.getTimeframe(telemetry);
  }

  toSensorHealth() {
    this.router.navigate(['sensor-health', this.asset()?.objectID]);
  }

  toSensorHistory(sensorID: number) {
    const historyItems = this.HistoryItems();
    if (!historyItems || historyItems?.length === 0) return;

    if (sensorID) {
      this.router.navigate(['sensor-history', this.asset()?.objectID, sensorID, -1]);
    } else {
      this.router.navigate(['sensor-history', this.asset()?.objectID, -1, -1]);
    }
  }

  toSensorValue(sensorID: number, measurementTypeID: number) {
    if (sensorID && measurementTypeID) {
      this.router.navigate(['sensor-value', this.asset()?.objectID, sensorID, measurementTypeID]);
    }
  }

  cancelRangePick(data: any) {
    data.openRangePicker = 0;

    const rangeVal = this.range();
    if (rangeVal[0] > rangeVal[1]) {
      this.range.set([rangeVal[1], rangeVal[0]]);
    }

    this.datePickers().forEach((item) => item.close());
  }

  dateRangeUpdatedfromGraph(event: any) {
    const currentRange = this.range();
    if (
      currentRange[0].toISOString() !== event[0].toISOString() ||
      currentRange[1].toISOString() !== event[1].toISOString()
    ) {
      this.setTimeFrameForAllDisplays(event[0], event[1], event[2]);
      this.range.set([event[0], event[1]]);
    }
  }

  openDocument(link: string) {
    window.open(link, '_blank', 'noreferrer');
  }

  onThumbnailLoadFailed() {
    this.sensorMarkers.set([]);
    this.resizeTrigger.set(() => {
      //console.log('resize');
    });
    this.thumbnailLoading.set(false);
    this.thumbnailError.set(true);
  }

  onThumbnailLoaded(event: Event) {
    const target = event.target as HTMLImageElement;

    this.resizeTrigger.set(() => {
      const nat_w = target.naturalWidth,
        nat_h = target.naturalHeight,
        client_w = target.clientWidth,
        client_h = target.clientHeight,
        ratio_w = client_w / nat_w,
        ratio_h = client_h / nat_h,
        ratio = ratio_w > ratio_h ? ratio_w : ratio_h,
        offset_w = ratio_w < ratio_h ? -(nat_w * ratio_h - client_w) * 0.5 : 0,
        offset_h = ratio_w > ratio_h ? -(nat_h * ratio_w - client_h) * 0.5 : 0;

      const MARKER_OFFSET = 19;
      const assetVal = this.asset();
      const selectedSensorId = this.selectedSensor();

      if (!assetVal?.sensors) return;

      const markers = assetVal.sensors
        .map((sensor: any) => {
          if (!sensor.markerX || !sensor.markerY || !sensor.markerText) return null;

          let x = sensor.markerX * ratio + offset_w;
          let y = sensor.markerY * ratio + offset_h;

          if (x < MARKER_OFFSET) x = MARKER_OFFSET;
          if (x > client_w - MARKER_OFFSET) x = client_w - MARKER_OFFSET;
          if (y < MARKER_OFFSET) y = MARKER_OFFSET;
          if (y > client_h - MARKER_OFFSET) y = client_h - MARKER_OFFSET;

          return {
            text: sensor.markerText,
            warning: sensor.Warning && !sensor.Critical && !sensor.Inactive,
            inactive: sensor.Inactive,
            critical: sensor.Critical,
            nodata: sensor.NoData,
            sensorID: sensor.sensorID,
            x,
            y,
            hidden: selectedSensorId ? selectedSensorId !== sensor.sensorID : false,
            selected: selectedSensorId ? selectedSensorId === sensor.sensorID : false,
          };
        })
        .filter((item: any) => !!item);

      this.sensorMarkers.set(markers);
    });

    this.resizeTrigger()();
    this.thumbnailLoading.set(false);
    this.thumbnailError.set(false);
  }

  onDocumentationAdded() {
    this.refresh(this.asset()?.objectID, true);
  }

  onHeaderImageClick() {
    const markers = this.sensorMarkers();
    if (markers && markers?.length > 0) this.onSensorDeselect();
  }

  onSensorDeselect() {
    this.router.navigate(['asset', this.asset()?.objectID, -1]);
  }

  onSensorSelect(sensorID: number) {
    const sensor = this.Sensor();
    if (sensor && sensor.sensorID === sensorID) {
      this.onSensorDeselect();
    } else {
      this.router.navigate(['asset', this.asset()?.objectID, sensorID]);
    }
  }

  isTelemetryTimeframeCustom(telemetry: any): boolean {
    const display = this.graphDisplays().find(
      (graphDisplay: any) =>
        graphDisplay?.currentTelemetry?.measurementTypeID === telemetry?.measurementTypeID &&
        graphDisplay?.currentTelemetry?.sensor?.sensorID === telemetry?.sensor?.sensorID
    );
    return !!display?.timeframe?.custom;
  }

  onTimeframeSelect(index: number): void {
    this.SensorDetailedTelemetry().forEach((telemetry: any) =>
      this.onTelemetryTimeframeSelect(index, telemetry)
    );
  }

  onTelemetryTimeframeSelect(index: number, telemetry: any): void {
    this.lastTimeframeSelectIndex.set(index);

    const display = this.graphDisplays().find(
      (graphDisplay: any) =>
        graphDisplay.currentTelemetry.measurementTypeID === telemetry.measurementTypeID &&
        graphDisplay.currentTelemetry.sensor.sensorID === telemetry.sensor.sensorID
    );
    if (!display || !display.graphData?.length) return;

    let firstMeasurement = null;
    let lastMeasurement = null;

    for (const gdata of display.graphData) {
      if (gdata?.metadata.displayGraph) {
        if (!firstMeasurement || gdata.metadata.firstMeasurement < firstMeasurement) {
          firstMeasurement = gdata.metadata.firstMeasurement;
        }
        if (!lastMeasurement || gdata.metadata.lastMeasurement > lastMeasurement) {
          lastMeasurement = gdata.metadata.lastMeasurement;
        }
      }
    }

    if (firstMeasurement) firstMeasurement = new Date(Date.parse(firstMeasurement as any));
    if (lastMeasurement) lastMeasurement = new Date(Date.parse(lastMeasurement as any));

    let end: any = lastMeasurement || new Date();
    let start: any = new Date(new Date(end).setDate(end.getDate() - 7));

    switch (index) {
      case 0:
        if (start < firstMeasurement!) {
          start = firstMeasurement!;
          end = new Date(new Date(start).setDate(start.getDate() + 7));
        }
        break;
      case 1:
        start = new Date(new Date(end).setDate(end.getDate() - 35));
        if (start < firstMeasurement!) {
          start = firstMeasurement!;
          end = new Date(new Date(start).setDate(start.getDate() + 35));
        }
        break;
      case 2:
        start = new Date(new Date(end).setMonth(end.getMonth() - 6));
        if (start < firstMeasurement!) {
          start = firstMeasurement!;
          end = new Date(new Date(start).setMonth(start.getMonth() + 6));
        }
        break;
    }

    this.setTimeFrameForAllDisplays(start, end, false);
    this.range.set([display.timeframe.start, display.timeframe.end]);
  }

  // onRangeStartPick(measurementTypeID: any, sensorID: any, event: any, endPickerID: any, data: any) {
  //   if (data.openRangePicker === 1) data.openRangePicker = 2;
  //   const current = this.range();
  //   const updated: [Date, Date] = [
  //     new Date(event),
  //     new Date(current[1]),
  //   ];
  //   this.range.set(updated);

  //   let lastMeasurement = data.metadata.lastMeasurement;
  //   if (lastMeasurement) {
  //     lastMeasurement = new Date(Date.parse(lastMeasurement));
  //     if (updated[1] > lastMeasurement) {
  //       updated[1] = lastMeasurement;
  //     }
  //   }

  //   const display = this.graphDisplays().find(
  //     (graphDisplay: any) =>
  //       (graphDisplay.currentTelemetry.measurementTypeID === measurementTypeID ||
  //         graphDisplay.graphData?.some(
  //           (item: any) => item.metadata.measurementTypeID === measurementTypeID
  //         )) &&
  //       graphDisplay.currentTelemetry.sensor.sensorID === sensorID
  //   );
  //   if (!display) return;

  //   if (
  //     updated[0].toISOString() !== display.timeframe.start.toISOString() ||
  //     updated[1].toISOString() !== display.timeframe.end.toISOString()
  //   ) {
  //     this.setTimeFrameForAllDisplays(updated[0], updated[1], true);
  //   }

  //   if (data.openRangePicker === 2) {
  //     const el = document.getElementById(endPickerID);
  //     if (el) el.click();
  //   }

  //   this.range.set(Array.from(updated));
  // }

  onRangeStartPick(
    measurementTypeID: number,
    sensorID: number,
    event: Date,
    endPickerID: any,
    data: any
  ): void {
    if (!event) {
      return;
    }

    const currentRange = this.range();

    const start = new Date(event);

    // keep previously selected end date
    let end = currentRange[1] ? new Date(currentRange[1]) : new Date(event);

    // never allow inverted range
    if (start > end) {
      end = start;
    }

    const nextRange: [Date, Date] = [start, end];

    this.range.set(nextRange);

    this.setTimeFrameForAllDisplays(nextRange[0], nextRange[1], true);

    if (data.openRangePicker === 1) {
      data.openRangePicker = 2;

      queueMicrotask(() => {
        document.getElementById(endPickerID)?.click();
      });
    }
  }

  onRangeEndPick(measurementTypeID: number, sensorID: number, event: Date, data: any) {
    data.openRangePicker = 0;
    const rangeVal = this.range();

    if (event < rangeVal[0]) {
      rangeVal[1] = rangeVal[0];
      rangeVal[0] = event;
    } else {
      rangeVal[1] = event;
    }

    const display = this.graphDisplays().find(
      (graphDisplay: any) =>
        (graphDisplay.currentTelemetry.measurementTypeID === measurementTypeID ||
          graphDisplay.graphData?.some(
            (item: any) => item.metadata.measurementTypeID === measurementTypeID
          )) &&
        graphDisplay.currentTelemetry.sensor.sensorID === sensorID
    );
    if (!display) return;

    if (
      rangeVal[0].toISOString() !== display.timeframe.start.toISOString() ||
      rangeVal[1].toISOString() !== display.timeframe.end.toISOString()
    ) {
      this.setTimeFrameForAllDisplays(rangeVal[0], rangeVal[1], true);
    }

    this.range.set([...rangeVal]);

    setTimeout(() => {
      data.openRangePicker = 0;
    });
  }

  openRangePicker(id: any, data: any) {
    data.openRangePicker = id.includes('end') ? 2 : 1;
    const el = document.getElementById(id);
    if (el) el.click();
  }

  // onRangePickerSelect(event: [Date, Date]) {
  //   this.setTimeFrameForAllDisplays(event[0], event[1], true);
  //   this.range.set(event);
  // }
  startonRangePickerSelect(event: Date[]): void {
    if (!event?.[0]) {
      return;
    }

    const currentRange = this.range();

    const start = event[0];

    const end = event[1] ?? currentRange?.[1] ?? event[0];

    const nextRange: [Date, Date] = [new Date(start), new Date(end)];

    this.range.set(nextRange);

    this.setTimeFrameForAllDisplays(nextRange[0], nextRange[1], true);
  }

  setTimeFrameForAllDisplays(start: Date, end: Date, custom: boolean) {
    this.graphDisplays().forEach((display) =>
      this.setDisplayTimeframe(display, start, end, custom)
    );
  }

  setDisplayTimeframe(display: GraphDisplay, start: Date, end: Date, custom: boolean) {
    if (display.currentTelemetry.measurementTypeID === 1068) {
      const steamLossAmountDisplay = this.graphDisplays().find(
        (graphDisplay) => graphDisplay.currentTelemetry.measurementTypeID === 1069
      );
      if (steamLossAmountDisplay)
        this.setDisplayTimeframe(steamLossAmountDisplay, start, end, custom);

      const steamLossKGDisplay = this.graphDisplays().find(
        (graphDisplay) => graphDisplay.currentTelemetry.measurementTypeID === 1070
      );
      if (steamLossKGDisplay) this.setDisplayTimeframe(steamLossKGDisplay, start, end, custom);
    }

    display.setTimeframe({ start, end, custom }, this);
  }

  rangePickerDisabledDate(data: any, pickerIndex: number): (current: Date) => boolean {
    if (!data) return () => false;

    const rangeVal = this.range();
    let otherDate: Date | null = null;

    if (pickerIndex === 1) otherDate = rangeVal[1];
    if (pickerIndex === 2) otherDate = rangeVal[0];

    if (otherDate) otherDate = new Date(otherDate.toDateString());

    let first = new Date(Date.parse(data.metadata.firstMeasurement));
    first = new Date(first.toDateString());

    let last = new Date(Date.parse(data.metadata.lastMeasurement));
    last = new Date(last.toDateString());

    return (current: Date) => {
      current = new Date(current.toDateString());
      return current < first || current > last || +current === +otherDate!;
    };
  }

  trackByMarker(index: number, marker: SensorMarker): number | undefined {
    return marker ? marker.sensorID : undefined;
  }

  getParentForBackNav(parentID: number): Location {
    let parent: any = this.assetsService.findLocation(parentID);
    while (
      parent &&
      parent.curLayer !== 'a' &&
      parent.curLayer !== 'b' &&
      parent.curLayer !== 'c'
    ) {
      if (
        parent?.Assets?.length > 25 &&
        !parent.IsAboveEquipment &&
        !parent.NextLayerIsAboveEquipment
      )
        break;

      parent = this.assetsService.findLocation(parent.parentID);
    }
    return parent;
  }

  isBreadcrumbClickable(): boolean {
    return true;
  }

  private sameDisplay(a: GraphDisplay, b: GraphDisplay): boolean {
    return (
      a.currentTelemetry?.measurementTypeID === b.currentTelemetry?.measurementTypeID &&
      a.currentTelemetry?.sensor?.sensorID === b.currentTelemetry?.sensor?.sensorID
    );
  }

  navToBreadcrumb(breadcrumb: any): void {
    if (!this.isBreadcrumbClickable()) return;

    if (breadcrumb.isAsset) {
      this.router.navigate(['asset', breadcrumb.objectID, -1]);
    } else if (breadcrumb.layerID === 1 || breadcrumb.layerID === 2) {
      this.router.navigate(['home', 'list', breadcrumb.objectID]);
    } else {
      this.router.navigate(['plant', breadcrumb.objectID]);
    }
  }

  goToNanoPreciseDashboard(): void {
    const windowReference: any = window.open('about:blank', '_blank');
    const assetVal = this.asset();
    if (!assetVal) return;

    this.assetsService.goToNanoPreciseDashboard(assetVal.objectID).then((result: any) => {
      if (result?.result) {
        windowReference.location = result.result;
      }
    });
  }

  getRulPercentage(rul: any) {
    return Math.round(rul * 100);
  }

  loadAdditionalInfo() {
    this.additionalInfoLoading.set(true);

    forkJoin([
      this.assetsService.getAdditionalInfo(this.asset()?.objectID),
      this.assetsService.getAdditionalInfoTypes(),
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([res, infoTypeResult]) => {
        if (!res || !infoTypeResult) {
          this.additionalInfoError.set(true);
        } else {
          this.additionalInfoError.set(false);

          this.addInfoValueTypes.set(infoTypeResult.infoTypes);
          this.addInfoDefaultFields.set(
            infoTypeResult.defaultFields.map((f: any) => {
              f.dropdownValues = f.dropdownValues ? JSON.parse(f.dropdownValues) : null;
              f.unit = f.unit ? JSON.parse(f.unit) : null;
              f.conversionFactor = f.conversionFactor ? JSON.parse(f.conversionFactor) : null;
              return f;
            })
          );

          this.groupAdditionalInformation(res);
        }
        this.additionalInfoLoading.set(false);
      });
  }

  async loadNotifications() {
    this.loadingNotifications.set(true);
    try {
      const notifications: any = await this.assetsService.getNotifications();
      const assetVal = this.asset();
      if (assetVal && Array.isArray(notifications)) {
        assetVal.notifications = notifications.filter((n: any) => n.objectID === assetVal.objectID);
        this.asset.set(new AssetDetail(assetVal, assetVal.breadcrumbs));
      }
    } catch (error) {
      logError(error);
    } finally {
      this.loadingNotifications.set(false);
    }
  }

  groupAdditionalInformation(loadedValues: AdditionalInfo[]) {
    const availableValues = loadedValues.map((v) => new AdditionalInfo(v));
    const availableTypes = loadedValues
      .map((t) => t.infoTypeID)
      .filter((t, i, a) => a.indexOf(t) === i);

    const grouped: any = availableTypes.map((typeID) => ({
      infoType: this.addInfoValueTypes().find((t) => t.id === typeID),
      infoValues: availableValues.filter((v) => v.infoTypeID === typeID),
      displayInfoValues: availableValues.filter(
        (v) => v.infoTypeID === typeID && (v.text || v.value)
      ),
    }));

    this.groupedInfoValues.set(grouped);
  }

  getProvidedAdditionalInformationLength(): number {
    return this.groupedInfoValues().filter((value: any) => value?.displayInfoValues?.length > 0)
      .length;
  }

  showHighTempText(): any {
    return this.asset()?.additionalInfo.find(
      (addInfoValue: any) => addInfoValue.text === 'High (up to 500°C)'
    );
  }

  closeHealthInfo(): void {
    this.openInfoPopup.set(false);
  }
}
